import * as React from 'react'

import { styled, cn } from '~/styled'

import { BannerContainer } from '../BannerContainer'
import { useBannerContext } from '../BannerContext'

const toDirection = {
  sm: 'flex-col',
  md: 'flex-row'
}

const toAlign = {
  sm: 'items-start',
  md: 'items-center'
}

const toWrap = {
  sm: 'flex-wrap',
  md: 'flex-nowrap'
}

const StyledBannerSlimContainer = styled(
  BannerContainer,
  {
    base: ['p-4'],
    variants: {
      sizeWorkaround: {
        sm: [],
        md: ['px-6']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

type TBannerSlimContainerProps = React.ComponentProps<
  typeof StyledBannerSlimContainer
>

export const BannerSlimContainer = ({
  className,
  ...rest
}: TBannerSlimContainerProps): React.JSX.Element => {
  const { size } = useBannerContext()

  const direction = React.useMemo(() => {
    if (typeof size === 'string') {
      return toDirection[size]
    }
    return 'flex-col md:flex-row'
  }, [size])

  const align = React.useMemo(() => {
    if (typeof size === 'string') {
      return toAlign[size]
    }
    return 'items-start md:items-center'
  }, [size])

  const wrap = React.useMemo(() => {
    if (typeof size === 'string') {
      return toWrap[size]
    }
    return 'flex-wrap md:flex-nowrap'
  }, [size])

  return (
    <StyledBannerSlimContainer
      {...rest}
      sizeWorkaround={size}
      className={cn(direction, align, 'gap-4', wrap, className)}
    />
  )
}

BannerSlimContainer.displayName = 'BannerSlimContainer'
